import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {FormUtil} from '../../utils';
import {TrackingService} from '../../services';

@Component({
    selector: 'app-edit-remark-modal',
    templateUrl: './edit-remark-modal.component.html',
    styleUrls: ['./edit-remark-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditRemarkModalComponent {
    public modalRef = inject(VwuiModalRef);
    public modalConfig =
        inject<VwuiModalConfig<{ remark?: string; readonly: boolean; saveText: string; }>>(VwuiModalConfig);
    private trackingService = inject(TrackingService);


    form = new UntypedFormGroup({
        remark: new UntypedFormControl('')
    });
    public saveText: string;
    public remark: string;
    public readonly: boolean;

    constructor() {
        const modalConfig = this.modalConfig;

        this.saveText = modalConfig.data.saveText;
        this.remark = modalConfig.data.remark;
        this.readonly = modalConfig.data.readonly;

        this.form = new UntypedFormGroup({
            remark: new UntypedFormControl(this.remark)
        });

        this.handleFormControls();
    }

    private handleFormControls(): void {
        this.form.enable();

        if (this.readonly) {
            this.form.disable();
        }
    }

    async submit() {
        try {
            FormUtil.validate(this.form);

            if (this.form.valid) {
                this.modalRef.close(this.form.value);
            }
        } catch (error) {
            this.trackingService.exception(error);
        }
    }
}
